import React, { RefObject } from "react";
import JoditEditor from "jodit-react";
import { Check, X } from "lucide-react";

interface EditorModalProps {
  editorRef: RefObject<any>;
  tempContent: string;
  handleEditorChange: (content: string) => void;
  handleCancelEdit: () => void;
  handleConfirmEdit: () => void;
}

const editorConfig = {
  height: 500,
  toolbarSticky: false,
  buttons: [
    "bold",
    "italic",
    "underline",
    "fontsize",
    "|",
    "ul",
    "ol",
    "|",
    "indent",
    "outdent",
    "|",
    "paragraph",
    "align",
    "|",
    "image",
    "table",
    "link",
  ],
  uploader: {
    insertImageAsBase64URI: true,
  },
  removeButtons: ["source"],
};

export const EditorModal: React.FC<EditorModalProps> = ({
  editorRef,
  tempContent,
  handleEditorChange,
  handleCancelEdit,
  handleConfirmEdit,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        zIndex: 1050,
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          width: "100%",
          maxWidth: "900px",
          padding: "24px",
          position: "relative",
          zIndex: 1060,
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h3 style={{ margin: 0 }}>Editar elemento (capa)</h3>
        </div>

        {/* Editor */}
        <div style={{ overflowX: "hidden" }}>
          <JoditEditor
            ref={editorRef}
            value={tempContent}
            config={editorConfig}
            onBlur={handleEditorChange}
          />
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            marginTop: "24px",
          }}
        >
          <button onClick={handleCancelEdit} className="btn btn-secondary">
            <X size={18} /> Cancelar
          </button>
          <button onClick={handleConfirmEdit} className="btn btn-success">
            <Check size={18} /> Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};
